module.exports = __webpack_public_path__ + "img/IMG_9033_L_BlackMatted_MockedUp.d9788a19.jpg";